import { GrcNotify, NotifyType } from '@grc/ui-package';
import {
  currenciesUrl,
  currencyService
} from '../../common/constants/url-constants';
import notify from '../common/notify';
import I18N from '../../i18n/interface';

export default async function GetCurrencyDetails(
  fetchData: any,
  status: boolean = true,
  localeData: I18N
) {
  try {
    const response = await fetchData(
      `${currenciesUrl}?isActive=${status}`,
      notify,
      currencyService
    );

    if (!!response && response.status === 200) {
      return Array.isArray(response.data) ? response.data : [];
    } else {
      GrcNotify({
        message: 'Failed to fetch currency details',
        status: NotifyType.Error
      });
    }
  } catch (error) {
    GrcNotify({
      message: localeData.FailedToFetchCurrencyDetailsNetworkError,
      status: NotifyType.Error
    });
  }
  return [];
}
